export const truncate = (value: string, maxLength: number) => {
  if (!value) return "";
  return value.length > maxLength
    ? `${value.slice(0, maxLength)}...`
    : value;
};